var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWord = function SvgWord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.943 15.576H9.408L7.667 9.669h1.788l.807 3.634h.046l.958-3.634h1.407l.957 3.646h.047l.807-3.646h1.788l-1.742 5.907h-1.534l-1.004-3.3h-.046l-1.003 3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.727 2.364a2.363 2.363 0 0 0-2.364 2.363v14.545a2.364 2.364 0 0 0 2.364 2.364h10.545a2.363 2.363 0 0 0 2.364-2.364V8.183a.606.606 0 0 0-.177-.428L14.245 2.54a.606.606 0 0 0-.429-.177h-7.09Zm-.814 1.549c.216-.216.509-.337.814-.337h6.84l4.857 4.858v10.838a1.152 1.152 0 0 1-1.152 1.152H6.727a1.151 1.151 0 0 1-1.152-1.152V4.727c0-.305.122-.598.338-.814Z"
  }))));
};
export default SvgWord;